import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import {DynamicComponent} from './dynamic.component';
import {DynamicComponentService} from './dynamic.service';


import { DialogComponent } from "./dialog/dialog.component";
import { DialogService } from "./dialog/dialog.service";
import { AlertDialogComponent } from "./dialog/alert.component";
import { ConfirmDialogComponent } from "./dialog/confirm.component";
import { PromptDialogComponent } from "./dialog/prompt.component";

import { DynamicEmptyComponent } from './dynamic.empty.component';


@NgModule({
    imports: [CommonModule, FormsModule],
    exports: [DynamicComponent, DialogComponent],
    declarations: [DynamicComponent, DialogComponent, AlertDialogComponent, ConfirmDialogComponent, PromptDialogComponent, DynamicEmptyComponent],
    providers: [DynamicComponentService, DialogService],
})
export class DynamicComponentsModule { }
